module.exports = __webpack_public_path__ + "static/media/signinwithapple.1ca9253c.png";